module.exports = __webpack_public_path__ + "static/img/counselor－4.a0cf011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/counselor－4.png
// module id = 3qPP
// module chunks = 1